/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 2.99976H18C18.465 2.99976 18.6975 2.99976 18.8882 3.05087C19.4059 3.18957 19.8102 3.59389 19.9489 4.11153C20 4.30228 20 4.53477 20 4.99976V4.99976V5.99976M12 2.99976H8.5M12 2.99976V6.99976"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 21H16M12 21H8M12 21V12M4 4L20 20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M12 3H17.5C17.9647 3 18.197 3 18.3902 3.03843C19.1836 3.19624 19.8038 3.81644 19.9616 4.60982C20 4.80302 20 5.03534 20 5.5V5.5V6M12 3H8.5M12 3V7M12 21H16M12 21H8M12 21V12M4 4L20 20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M12 3H17.5C17.9647 3 18.197 3 18.3902 3.03843C19.1836 3.19624 19.8038 3.81644 19.9616 4.60982C20 4.80302 20 5.03534 20 5.5V5.5V6M12 3H8.5M12 3V7M12 21H16M12 21H8M12 21V12M4 4L20 20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 3H17.5C17.9647 3 18.197 3 18.3902 3.03843C19.1836 3.19624 19.8038 3.81644 19.9616 4.60982C20 4.80302 20 5.03534 20 5.5V5.5V6M12 3H8.5M12 3V7M12 21H16M12 21H8M12 21V16.5M4 4L20 20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 3H17.5C17.9647 3 18.197 3 18.3902 3.03843C19.1836 3.19624 19.8038 3.81644 19.9616 4.60982C20 4.80302 20 5.03534 20 5.5V5.5V6M12 3H8.5M12 3V7M12 21H16M12 21H8M12 21V12M4 4L20 20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M12 3H17.5C17.9647 3 18.197 3 18.3902 3.03843C19.1836 3.19624 19.8038 3.81644 19.9616 4.60982C20 4.80302 20 5.03534 20 5.5V5.5V6M12 3H8.5M12 3V7M12 21H16M12 21H8M12 21V12M4 4L20 20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
